import type { SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export const ChevronLeftBold = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="11"
    height="16"
    viewBox="0 0 11 16"
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.82824 8.00015L10.414 3.41436L7.5856 0.585938L0.171387 8.00015L7.5856 15.4144L10.414 12.5859L5.82824 8.00015Z"
      fill="currentColor"
    />
  </svg>
);
